import { reduceValidationResults } from '../validators';
import { t } from '../../../utils/translate';

export const required = state => {
  const fieldValids = state.values.map(v => !!v.value.trim().length);
  const allFieldsValid = fieldValids.every(v => v === true);
  const isForgiven = state.values.some(v => !v.isTouched);
  const isValid = allFieldsValid || isForgiven;
  const errorMessages = isValid
    ? null
    : state.errorMessages.concat([t('must_fill_all')]);
  return reduceValidationResults(state, {
    errorMessages,
    fieldValids,
    isValid,
  });
};
